/**
 * Persisted on/off preference for the on-screen VPS/FPS readout
 * (StatsHud.ts — "{fps} FPS · Localization {confidence}%") AND (2026-07-18,
 * user request) the green "Localized" status pill once localization
 * succeeds — see LocalizationStatus.ts's applyVisibility(). Toggled from
 * the 🐞 debug panel's "📶 VPS/FPS" button. Defaults to OFF: both readouts
 * are debug-oriented, and the user asked for the status pill to disappear
 * once localized unless this is explicitly turned on (previously this
 * defaulted to on — flipped 2026-07-18 per user request).
 */

const KEY = 'navme.debug.statsHudVisible';

export function isStatsHudVisible(): boolean {
  try {
    const v = localStorage.getItem(KEY);
    return v === '1'; // unset (null) → off, same as any other explicit "off"
  } catch {
    return false; // private mode / quota — default off
  }
}

export function setStatsHudVisible(visible: boolean): void {
  try {
    localStorage.setItem(KEY, visible ? '1' : '0');
  } catch {
    /* quota/private mode — preference just won't persist across reloads */
  }
}
